// extracted by mini-css-extract-plugin
export default {"dashboard":"TeamCreator_dashboard__MfOV4"};